// DialogConfirm.jsx
import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const DialogConfirm = ({
  title,
  subtitle,
  icon,
  confirmAction = () => {},
  cancelAction = () => {},
  confirmText = "Confirm",
  cancelText = "Cancel",
  cancelButtonClass = "w-full",
  confirmButtonClass = "w-full",
  content,
  onClose,
  containerClass = 'lg:w-fit w-[90%]' 
}) => {
  const [visible, setVisible] = React.useState(true);

  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };

  return (
    <Dialog open={visible} onOpenChange={setVisible}>
      <DialogContent className={`!p-6 text-center card ${containerClass}`}>
        <DialogHeader>
          {icon && (
            <div className="flex justify-center mb-4">
              {typeof icon === "string" ? (
                <img src={icon} alt="icon" className="w-12 h-12" />
              ) : (
                icon
              )}
            </div>
          )}
          <DialogTitle className="hidden"></DialogTitle>
          { title && <p className="text-lg font-semibold text-center !mt-0">{title}</p>}
          { subtitle && <p className="text-sm text-muted text-center font-normal !mt-0">{subtitle}</p>}
        </DialogHeader>

        <DialogDescription className={`mt-4 ${content ? "" : "hidden"}`}>{content}</DialogDescription>

        <div className="flex gap-3 mt-6 justify-center">
          <Button
            className={cancelButtonClass}
            variant="dark"
            onClick={() => {
              handleClose();
              cancelAction();
            }}
          >
            {cancelText}
          </Button>
          <Button
            className={confirmButtonClass}
            onClick={() => {
              handleClose();
              confirmAction();
            }}
          >
            {confirmText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};